import { Get, Patch } from "./apiHelper";
import { BillingPackage } from "../interfaces/BillingPackages";

const billingPackagesRoot = "/api/billing";

export const getBillingPackages = async (clientId?: number): Promise<BillingPackage[]> => {
  const response = await Get(
    `${billingPackagesRoot}/packages${clientId ? `?clientId=${clientId}` : ""}`
  );
  return response.data as BillingPackage[];
};

export const patchBillingPackage = async (
  data: BillingPackage,
  id: number
): Promise<BillingPackage> => {
  const response = await Patch(`${billingPackagesRoot}/package/${id}`, { data }, true);
  return response.data as BillingPackage;
};

export const cancelBillingPackageApi = async (id: number): Promise<BillingPackage> => {
  const response = await Patch(`${billingPackagesRoot}/package/${id}/cancel`, {}, true);
  return response.data as BillingPackage;
};
